// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  font-family: arial;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.Menu {
  width: 500px;
  height: 500px;
  border-radius: 10px;
  background-color: lightseagreen;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}


.Menu input, button {
  width: 300px;
  height: 50px;
  margin: 5px;
  border: none;
  border-radius: 5px;
  font-size: 20px;
}

.option-btn {
  background-color: white;
  color: #333;
  transition: background 0.2s, color 0.2s;
}

.option-btn.selected {
  background-color: #ffb347;
  color: #222;
  font-weight: bold;
}

button:hover {
  cursor: pointer;
}

.Quiz {
  width: 500px;
  height: 500px;
  border-radius: 10px;
  background-color: lightseagreen;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.Menu, .Quiz, .EndScreen h1 {
  color: white;
}

.EndScreen {
  width: 500px;
  height: 500px;
  border-radius: 10px;
  background-color: lightseagreen;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#nextQuestion {
  width: 200px;
}

h3 {
  color: #ffffff;

}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;;AAEhB","sourcesContent":[".App {\n  text-align: center;\n  font-family: arial;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.Menu {\n  width: 500px;\n  height: 500px;\n  border-radius: 10px;\n  background-color: lightseagreen;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n\n.Menu input, button {\n  width: 300px;\n  height: 50px;\n  margin: 5px;\n  border: none;\n  border-radius: 5px;\n  font-size: 20px;\n}\n\n.option-btn {\n  background-color: white;\n  color: #333;\n  transition: background 0.2s, color 0.2s;\n}\n\n.option-btn.selected {\n  background-color: #ffb347;\n  color: #222;\n  font-weight: bold;\n}\n\nbutton:hover {\n  cursor: pointer;\n}\n\n.Quiz {\n  width: 500px;\n  height: 500px;\n  border-radius: 10px;\n  background-color: lightseagreen;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.Menu, .Quiz, .EndScreen h1 {\n  color: white;\n}\n\n.EndScreen {\n  width: 500px;\n  height: 500px;\n  border-radius: 10px;\n  background-color: lightseagreen;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n#nextQuestion {\n  width: 200px;\n}\n\nh3 {\n  color: #ffffff;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
